export const style = {
  Typography: {
    sx: {
      maxWidth: 200,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
  },
  Box: {
    sx: (color: string) => {
      return {
        display: 'flex',
        alignItems: 'center',
        color,
        fontSize: '14px',
        gap: 1,
        svg: {
          width: '22px',
          height: '22px',
          marginTop: '-3px',
        },
        '& .MuiTypography-root': {
          fontWeight: 600,
        },
      };
    },
  },
} as const;
